import {Plugin} from 'prosemirror-state';
import {Decoration, DecorationSet} from 'prosemirror-view';
import {
  findTable,
  getCellsInColumn,
  getCellsInRow,
  isColumnSelected,
  isRowSelected,
  isTableSelected,
  selectColumn,
  selectRow,
  selectTable,
} from '../helper/table';

export const tableTooltip = dispatch => new Plugin({
    props: {
        decorations: state => {
            const {doc, selection} = state;
            const table = findTable(selection);

            if (!table) {
                return;
            }

            const decorations = [];

            const firstColumnCells = getCellsInColumn(0)(selection);
            if (firstColumnCells) {
                firstColumnCells.forEach(({pos}, index) => {
                    if (index === 0) {
                        decorations.push(
                            Decoration.widget(pos + 1, () => {
                                let className = "grip-table";
                                const selected = isTableSelected(selection);
                                if (selected) {
                                    className += " selected";
                                }
                                const grip = document.createElement("div");
                                grip.id = 'grip-table-' + table.pos;
                                grip.className = className;
                                grip.addEventListener('mousedown', e => {
                                    e.preventDefault();
                                    e.stopImmediatePropagation();
                                    dispatch(selectTable(state.tr));
                                });
                                return grip;
                            })
                        );
                    }
                    decorations.push(
                        Decoration.widget(pos + 1, () => {
                            const rowSelected = isRowSelected(index)(selection);
                            let className = "grip-row";
                            if (rowSelected) {
                                className += " selected";
                            }
                            if (index === 0) {
                                className += " first";
                            }
                            if (index === firstColumnCells.length - 1) {
                                className += " last";
                            }

                            const grip = document.createElement("div");
                            grip.id = 'grip-row-' + table.pos + '-' + index;
                            grip.className = className;
                            grip.index = index;
                            grip.addEventListener('mousedown', e => {
                                e.preventDefault();
                                e.stopImmediatePropagation();
                                dispatch(selectRow(index)(state.tr));
                            });
                            return grip;
                        })
                    );
                });
            }

            const firstRowCells = getCellsInRow(0)(selection);
            if (firstRowCells) {
                firstRowCells.forEach(({pos}, index) => {
                    decorations.push(
                        Decoration.widget(pos + 1, () => {
                            const colSelected = isColumnSelected(index)(selection);
                            let className = "grip-column";
                            if (colSelected) {
                                className += " selected";
                            }
                            if (index === 0) {
                                className += " first";
                            }
                            if (index === firstRowCells.length - 1) {
                                className += " last";
                            }
                            const grip = document.createElement("div");
                            grip.id = 'grip-column-' + table.pos + '-' + index;
                            grip.className = className;
                            grip.index = index;
                            grip.addEventListener('mousedown', e => {
                                e.preventDefault();
                                e.stopImmediatePropagation();
                                dispatch(selectColumn(index)(state.tr));
                            });
                            return grip;
                        })
                    );
                });
            }

            return DecorationSet.create(doc, decorations);
        }
    }
});